/**
 * Analytics — Google Analytics 4 + Meta (Facebook) Pixel
 * =======================================================
 * Carregamento opcional via env vars:
 *   REACT_APP_GA4_ID         — ex.: G-XXXXXXXXXX
 *   REACT_APP_META_PIXEL_ID  — ex.: 123456789012345
 *
 * Comportamento:
 *   - initAnalytics() injeta os scripts apenas se as env vars estiverem definidas.
 *   - Idempotente (safe pra chamar várias vezes).
 *   - trackPageview() é chamado automaticamente em mudanças de rota.
 *   - trackLead(), trackContact() podem ser chamados em conversões importantes.
 *
 * Privacy:
 *   - GA4 com anonymize_ip
 *   - Carregamento async (não bloqueia render)
 */

const GA4_ID = process.env.REACT_APP_GA4_ID;
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

let initialized = false;

export const hasAnalytics = () => Boolean(GA4_ID || META_PIXEL_ID);

export const initAnalytics = () => {
  if (initialized || typeof window === 'undefined') return;
  initialized = true;

  // -------- Google Analytics 4 --------
  if (GA4_ID) {
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', GA4_ID, {
      anonymize_ip: true,
      send_page_view: false, // controlamos manualmente em trackPageview()
    });
  }

  // -------- Meta (Facebook) Pixel --------
  if (META_PIXEL_ID) {
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', META_PIXEL_ID);
  }
};

export const trackPageview = (path) => {
  if (typeof window === 'undefined') return;
  const url = path || window.location.pathname + window.location.search;
  if (GA4_ID && window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: url,
      page_location: window.location.href,
      page_title: document.title,
    });
  }
  if (META_PIXEL_ID && window.fbq) {
    window.fbq('track', 'PageView');
  }
};

export const trackEvent = (name, params = {}) => {
  if (typeof window === 'undefined') return;
  if (GA4_ID && window.gtag) window.gtag('event', name, params);
  if (META_PIXEL_ID && window.fbq) window.fbq('trackCustom', name, params);
};

export const trackLead = (params = {}) => {
  if (typeof window === 'undefined') return;
  if (GA4_ID && window.gtag) {
    window.gtag('event', 'generate_lead', { currency: 'BRL', value: 0, ...params });
  }
  if (META_PIXEL_ID && window.fbq) {
    window.fbq('track', 'Lead', { currency: 'BRL', ...params });
  }
};

export const trackContact = (params = {}) => {
  if (typeof window === 'undefined') return;
  if (GA4_ID && window.gtag) window.gtag('event', 'contact', params);
  if (META_PIXEL_ID && window.fbq) window.fbq('track', 'Contact', params);
};
